import React, {
  Component
} from "react";
import {
  connect
} from "react-redux";
import {Group} from "react-konva";
import {InchUtility} from "../../../lib/pipe-dataset";
import ManifoldTeeComponent from "./manifold-tee-component";
import ManifoldCornerComponent from "./manifold-corner-component";
import {
  PIPE_MANIFOLD_TEE_TYPE,
  PIPE_ELEMENT_TYPE_SINGLE_TEE,
  PIPE_ELEMENT_TYPE_DOUBLE_TEE,
  PIPE_ELEMENT_TYPE_TRIPLE_TEE,
  PIPE_ELEMENT_TYPE_BEND,
  PIPE_BED_UPPER_MANIFOLD,
  PIPE_FLOW_ARROW_ORIENTATION,
  PIPE_FLOW_BASIN_POSITION
} from "../../../lib/types"
import {
  doesPipeFlowDirectionStartOnTop,
  doesPipeFlowDirectionEndOnTop,
  doesPipeFlowDirectionStartLeft,
  doesPipeFlowDirectionStartRight,
  doesPipeFlowDirectionEndLeft,
  doesPipeFlowDirectionEndRight,
} from "../../../actions/pipe-bed-actions";

class PipeUpperRowComponent extends Component {

  get arrowOrientation() {
    const {
      doesPipeFlowDirectionStartOnTop,
      doesPipeFlowDirectionEndOnTop,
      doesPipeFlowDirectionStartLeft,
      doesPipeFlowDirectionEndRight
    } = this.props;

    const result = {
      vertical: doesPipeFlowDirectionStartOnTop() ? PIPE_FLOW_ARROW_ORIENTATION.DOWN : PIPE_FLOW_ARROW_ORIENTATION.UP,
      horizontal: (
        (doesPipeFlowDirectionStartOnTop() && doesPipeFlowDirectionStartLeft()) ||
        (doesPipeFlowDirectionEndOnTop() && doesPipeFlowDirectionEndRight())) ? PIPE_FLOW_ARROW_ORIENTATION.RIGHT : PIPE_FLOW_ARROW_ORIENTATION.LEFT
    };

    return result;
  }

  get cornerWidth() {
    return this.props.rowSpacing.px - ((this.props.rowSpacing.px / 2) - (this.props.pipeOD / 2))
  }

  renderManifolds = () => {
    let componentIndex = 1;
    let cumulativeOffset = this.props.rowSpacing.px;

    const singleManifolds = [...new Array(this.props.numberOfManifoldTeesSingles)].map((n, i) => {
      let id = {
        section: PIPE_BED_UPPER_MANIFOLD,
        index: componentIndex++,
        type: PIPE_ELEMENT_TYPE_SINGLE_TEE
      };
      const x = (i * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.SINGLE) + cumulativeOffset);
      return <ManifoldTeeComponent arrowOrientation={this.arrowOrientation} key={i} id={id}
                                   manifoldType={PIPE_MANIFOLD_TEE_TYPE.SINGLE} x={x} y={0}/>;
    });
    cumulativeOffset = cumulativeOffset + (this.props.numberOfManifoldTeesSingles * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.SINGLE));

    const doubleManifolds = [...new Array(this.props.numberOfManifoldTeesDoubles)].map((n, i) => {
      let id = {
        section: PIPE_BED_UPPER_MANIFOLD,
        index: componentIndex++,
        type: PIPE_ELEMENT_TYPE_DOUBLE_TEE
      };
      const x = (i * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.DOUBLE)) + cumulativeOffset;
      return <ManifoldTeeComponent arrowOrientation={this.arrowOrientation} key={i} id={id}
                                   manifoldType={PIPE_MANIFOLD_TEE_TYPE.DOUBLE} x={x} y={0}/>;
    });
    cumulativeOffset = cumulativeOffset + (this.props.numberOfManifoldTeesDoubles * (this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.DOUBLE));

    const tripleManifolds = [...new Array(this.props.numberOfManifoldTeesTriples)].map((n, i) => {
      let id = {
        section: PIPE_BED_UPPER_MANIFOLD,
        index: componentIndex++,
        type: PIPE_ELEMENT_TYPE_TRIPLE_TEE
      };
      const x = (i * this.props.rowSpacing.px * PIPE_MANIFOLD_TEE_TYPE.TRIPLE) + cumulativeOffset;
      return <ManifoldTeeComponent arrowOrientation={this.arrowOrientation} key={i} id={id}
                                   manifoldType={PIPE_MANIFOLD_TEE_TYPE.TRIPLE} x={x} y={0}/>;
    });

    let leftCornerId = {
      section: PIPE_BED_UPPER_MANIFOLD,
      index: 0,
      type: PIPE_ELEMENT_TYPE_BEND
    };
    let rightCornerId = {
      section: PIPE_BED_UPPER_MANIFOLD,
      index: componentIndex,
      type: PIPE_ELEMENT_TYPE_BEND
    };

    if (this.props.numberOfPipeRows <= 0) {
      //if no rows then avoid placing corner manifolds
      return []
    }

    return (
      <React.Fragment>
        <ManifoldCornerComponent arrowOrientation={this.arrowOrientation} id={leftCornerId}
                                 cornerWidth={this.cornerWidth} x={0} y={0}
                                 accessoryScaleX={1}
                                 accessoryScaleY={1}
                                 accessoryRotation={0}
                                 basinPosition={PIPE_FLOW_BASIN_POSITION.TOP_LEFT}
                                 />
        {singleManifolds}
        {doubleManifolds}
        {tripleManifolds}
        <ManifoldCornerComponent arrowOrientation={this.arrowOrientation} id={rightCornerId} scaleX={-1}
                                 cornerWidth={this.cornerWidth} x={this.props.bedWidth}
                                 y={0}
                                 accessoryScaleX={1}
                                 accessoryScaleY={1}
                                 accessoryRotation={90}
                                 basinPosition={PIPE_FLOW_BASIN_POSITION.TOP_RIGHT}
                                 />
      </React.Fragment>);
  };

  render() {
    return (
      <Group
        x={0}
        y={0}
      >
        {this.renderManifolds()}
      </Group>
    );
  }
}

const mapStateToProps = state => {
  return {
    //...
    pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
    bedWidth: state.pipeBed.pipeBedDimensions.width.px,
    perimeterOffset: new InchUtility(state.pipeGlobals.pipePerimeterOffset),
    manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px,
    numberOfPipeRows: state.pipeBed.numberOfPipeRows,
    rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
    numberOfManifoldTeesTriples: state.pipeBed.manifoldTeeDistribution.triples,
    numberOfManifoldTeesDoubles: state.pipeBed.manifoldTeeDistribution.doubles,
    numberOfManifoldTeesSingles: state.pipeBed.manifoldTeeDistribution.singles,
    pipeFlowDirection: state.pipeGlobals.pipeFlowDirection,
  };
};
export default connect(
  mapStateToProps, {
    doesPipeFlowDirectionStartOnTop,
    doesPipeFlowDirectionEndOnTop,
    doesPipeFlowDirectionStartLeft,
    doesPipeFlowDirectionStartRight,
    doesPipeFlowDirectionEndLeft,
    doesPipeFlowDirectionEndRight,
  }
)(PipeUpperRowComponent);




// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/pipe-upper-row-component.js